'use client';

import { useEffect, useState } from 'react';

// Navigator 확장 인터페이스 정의
interface NavigatorUAData {
  userAgentData?: {
    mobile?: boolean;
  };
  maxTouchPoints?: number;
}

/**
 * UserAgent를 통해 모바일 여부를 판단하는 훅
 * - SSR 안전 처리: navigator 유무 체크
 * - 초기 렌더에서 한 번만 UA 검사
 * - 타입 안전성 강화 및 성능 최적화
 */
export const useUserAgentMobile = () => {
  // 서버에서는 undefined, 클라이언트에서만 계산
  const [isMobile, setIsMobile] = useState<boolean | undefined>(
    typeof window === 'undefined' ? undefined : false,
  );

  useEffect(() => {
    if (typeof navigator === 'undefined') return;

    const nav = navigator as Navigator & NavigatorUAData;

    const uaDataMobile = nav.userAgentData?.mobile;
    if (typeof uaDataMobile === 'boolean') {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- SSR 하이드레이션 게이트: 마운트 1회 navigator/UA 검사 후 모바일 여부를 설정하는 의도적 패턴
      setIsMobile(uaDataMobile);

      return;
    }

    const ua = navigator.userAgent;
    const isProbablyIPad =
      /iPad|Macintosh/i.test(ua) && (nav.maxTouchPoints ?? 0) > 1;
    if (isProbablyIPad) {
      setIsMobile(true);

      return;
    }

    const mobileRegex =
      /android|webos|iphone|ipod|blackberry|iemobile|opera mini|mobile|ipad/i;
    setIsMobile(mobileRegex.test(ua));
  }, []);

  // undefined인 경우 false로 반환 (SSR 호환성)
  return isMobile ?? false;
};
